import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * Search by Image experiment arms. treatment-a is the current camera / popover /
 * bottom-sheet design; treatment-b's distinct design ships in a follow-up. One base
 * call per arm so Amplitude exposure fires for every bucket, not just the one the UI reads.
 */
export const useSearchByImageExperiment = () => {
    const hasControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchByImage,
        AmplitudeVariants.SearchByImage.Control
    );

    const hasTreatmentA = useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchByImage,
        AmplitudeVariants.SearchByImage.TreatmentA
    );

    const hasTreatmentB = useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchByImage,
        AmplitudeVariants.SearchByImage.TreatmentB
    );

    return {
        hasControl,
        hasTreatmentA,
        hasTreatmentB,
    };
};
